/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedLevel } from './exportedLevel';
import type { ExportedModuleOutputWorkload } from './exportedModuleOutputWorkload';
import type { ExportedTaskOutput } from './exportedTaskOutput';
import type { ExportedModuleOutputSourceModuleId } from './exportedModuleOutputSourceModuleId';

/**
 * Module export format
 */
export interface ExportedModuleOutput {
  title: string;
  description?: string;
  language?: string;
  levels?: ExportedLevel[];
  workload?: ExportedModuleOutputWorkload;
  tasks?: ExportedTaskOutput[];
  author_id: string;
  source_module_id?: ExportedModuleOutputSourceModuleId;
}
